// TODO: Reinstate when switching to new category enum values
// export enum EventRequestCategory {
//     MOVIE_SERIES = 'movie_series',
//     GAMING = 'gaming',
//     OWN_CONTENT = 'own_content',
//     PRESENTATION = 'presentation',
//     BUSINESS = 'business',
//     DISCOVER = 'discover',
//     EDUCATION = 'education'
// }
export enum EventRequestCategory {
    MOVIE_SERIES = 0,
    GAMING = 1,
    OWN_CONTENT = 2,
    PRESENTATION = 3,
    BUSINESS = 4,
    DISCOVER = 5,
    EDUCATION = 6
}
